export default "__VITE_ASSET__4c053e15__"